import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import { BiData } from '@wix/da-bi/pkg/events';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenuV2';
const MoreMenu = ({ isLoggedIn, className, menuClassName })=>{
    const { t } = useTranslation();
    const dreamupLink = isLoggedIn ? Url.dreamupLink() : 'https://www.dreamup.com';
    const items = useMemo(()=>[
            {
                items: [
                    {
                        key: 'groups',
                        label: t('siteHeader.groups'),
                        link: Url.buildFromPath(URLS.GROUPS),
                        biData: BiData({
                            evid: 700,
                            link_name: 'groups',
                            link_url: Url.buildFromPath(URLS.GROUPS)
                        })
                    },
                    {
                        key: 'forum',
                        label: t('siteHeader.forum'),
                        link: Url.buildFromPath(URLS.FORUM),
                        biData: BiData({
                            evid: 700,
                            link_name: 'forum',
                            link_url: Url.buildFromPath(URLS.FORUM)
                        })
                    },
                    {
                        key: 'dreamup',
                        label: t('siteHeader.dreamup'),
                        link: dreamupLink,
                        target: isLoggedIn ? undefined : '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'dreamup',
                            link_url: dreamupLink
                        })
                    }
                ]
            },
            {
                items: [
                    {
                        key: 'whatsNew',
                        label: t('siteHeader.whatsNew'),
                        link: Url.to(URLS.TEAM),
                        target: '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'whatsNew',
                            link_url: Url.to(URLS.TEAM)
                        })
                    },
                    {
                        key: 'betaTesting',
                        newTag: true,
                        label: t('siteHeader.betaTesting'),
                        link: URLS.BETA_TESTING,
                        target: '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'betaTesting',
                            link_url: URLS.BETA_TESTING
                        })
                    },
                    {
                        key: 'monetize',
                        label: t('siteHeader.monetize'),
                        link: URLS.DEVIANTART_SELL,
                        target: '_blank',
                        biData: BiData({
                            evid: 700,
                            link_name: 'deviantartsell',
                            link_url: URLS.DEVIANTART_SELL
                        })
                    },
                    {
                        key: 'create-group',
                        label: t('siteHeader.createGroup'),
                        link: Url.to(URLS.GROUPS_CREATE),
                        biData: BiData({
                            evid: 700,
                            link_name: 'create-group',
                            link_url: Url.to(URLS.GROUPS_CREATE)
                        })
                    }
                ]
            }
        ], [
        t,
        dreamupLink,
        isLoggedIn
    ]);
    return /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, {
        className: className,
        standardMenuProps: {
            className: menuClassName
        },
        popperManagerProps: {
            isInPopup: true
        },
        placement: "bottom-end",
        openOnHover: true,
        items: items,
        size: "large",
        variant: "main",
        icon: EllipsisIcon,
        "aria-label": t('siteHeader.more')
    });
};
MoreMenu.displayName = 'MoreMenu';
export default MoreMenu;
